<template>
  <div v-if="mode !== 'matriz'" class="comedor-strip">
    <button
      v-for="cid in activeIds"
      :key="cid"
      @click="$emit('update:focused', cid)"
      class="strip-tab"
      :class="{ 'strip-tab--active': focused === cid }"
    >
      {{ getCenter(cid)?.name || cid }}
      <span
        v-if="lineCount(cid) > 0"
        class="strip-badge"
        :class="{ 'strip-badge--active': focused === cid }"
      >{{ lineCount(cid) }}</span>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  activeIds: { type: Array,  required: true },
  focused:   { type: [String, Number], default: null },
  cart:      { type: Object, required: true },
  mode:      { type: String, required: true },
  store:     { type: Object, required: true },
})

defineEmits(['update:focused'])

function getCenter(id) {
  return props.store.getCenterById(id)
}

function lineCount(cid) {
  return Object.values(props.cart[cid] || {}).filter(q => q > 0).length
}
</script>

<style scoped>
.comedor-strip {
  display: flex;
  gap: 8px;
  padding: 0 24px;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
  overflow-x: auto;
  flex-shrink: 0;
}

.strip-tab {
  padding: 14px 4px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-2);
  font-family: var(--ff-head);
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
}

.strip-tab--active {
  border-bottom-color: var(--primary);
  color: var(--text);
}

.strip-badge {
  padding: 2px 7px;
  border-radius: 999px;
  background: var(--primary-soft);
  color: var(--primary);
  font-size: 11px;
  font-weight: 700;
}

.strip-badge--active {
  background: var(--primary);
  color: #fff;
}
</style>
